// extracted by mini-css-extract-plugin
export default {"resumeProjects":"ResumeProjects_resumeProjects__s4Ni1","resumeProject":"ResumeProjects_resumeProject__pJsSD"};